import React from 'react';
import { supabase } from '../lib/supabase';

export class QuillImageUpload {
  quill: any;
  options: any;
  range: any;
  fileHolder: HTMLInputElement | null = null;

  constructor(quill: any, options: any = {}) {
    this.quill = quill;
    this.options = options;
    this.range = null;

    if (typeof this.options.upload !== 'function') {
      console.warn('[Missing config] upload function that returns a promise is required');
    }

    const toolbar = this.quill.getModule('toolbar');
    if (toolbar) {
      toolbar.addHandler('image', this.selectLocalImage.bind(this));
    }
  }

  generateDatePath() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  }

  selectLocalImage() {
    this.range = this.quill.getSelection();
    this.fileHolder = document.createElement('input');
    this.fileHolder.setAttribute('type', 'file');
    this.fileHolder.setAttribute('accept', 'image/*');
    this.fileHolder.setAttribute('style', 'visibility:hidden');

    this.fileHolder.onchange = this.fileChanged.bind(this);

    document.body.appendChild(this.fileHolder);
    this.fileHolder.click();

    window.requestAnimationFrame(() => {
      if (this.fileHolder && document.body.contains(this.fileHolder)) {
        document.body.removeChild(this.fileHolder);
      }
    });
  }

  fileChanged() {
    const file = this.fileHolder?.files?.[0];
    if (!file) return;

    const fileReader = new FileReader();

    fileReader.addEventListener(
      'load',
      () => {
        const base64ImageSrc = fileReader.result as string;
        this.insertToEditor(base64ImageSrc);
      },
      false
    );

    if (file) {
      fileReader.readAsDataURL(file);
    }
  }

  insertToEditor(url: string) {
    // Show loading placeholder
    const range = this.range;
    this.quill.insertEmbed(range.index, 'image', `${url}`);
    this.quill.setSelection(range.index + 1, 0);

    const base64ImageSrc = url;
    const base64Data = base64ImageSrc.split(',')[1];
    const mimeType = base64ImageSrc.split(',')[0].split(':')[1].split(';')[0];
    
    // Convert base64 to blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    // Upload to Supabase
    this.uploadToSupabase(blob, range.index);
  }

  async uploadToSupabase(blob: Blob, index: number) {
    try {
      // Create unique filename with date-based path
      const fileExt = blob.type.split('/')[1];
      const fileName = `${Date.now()}-${Math.random().toString(36).substring(2)}.${fileExt}`;
      const datePath = this.generateDatePath();
      const filePath = `posts/content/${datePath}/${fileName}`;

      // Upload to Supabase Storage
      const { data, error } = await supabase.storage
        .from('vmon')
        .upload(filePath, blob, {
          cacheControl: '3600',
          upsert: false
        });

      if (error) {
        throw error;
      }

      // Get public URL
      const { data: { publicUrl } } = supabase.storage
        .from('vmon')
        .getPublicUrl(filePath);

      // Replace the base64 image with the uploaded URL
      const delta = this.quill.getContents();
      const ops = delta.ops || [];
      
      for (let i = 0; i < ops.length; i++) {
        if (ops[i].insert && ops[i].insert.image && typeof ops[i].insert.image === 'string' && ops[i].insert.image.startsWith('data:')) {
          ops[i].insert.image = publicUrl;
          break;
        }
      }
      
      this.quill.setContents(delta);
      
    } catch (error) {
      console.error('Error uploading image:', error);
      // Remove the failed image
      this.quill.deleteText(index, 1);
      alert('Có lỗi xảy ra khi upload ảnh. Vui lòng thử lại.');
    }
  }
}